import React from 'react';
import styles from 'Custom/FooterDropdown/index.module.scss';
import RawAccordion from 'Nori/Accordion';

const FooterDropdown = ({ className = '', ...props }) => (
  <RawAccordion className={`${styles.footerAccordion}`} {...props} />
);

export default FooterDropdown;
